import { Box } from '@zillow/constellation-10';
import { LeasesCard, PropertyConditionCard, RentersInsuranceCard } from '../Documents';
import type {
  YourRentalLeaseSectionDto,
  YourRentalListingSectionDto,
  YourRentalPropertyConditionSectionDto,
  YourRentalRinsCardDto,
} from '@zg-rentals/ts-your-rental-api-client';

type DocumentsProps = {
  leaseSection?: YourRentalLeaseSectionDto;
  propertyConditionSection?: YourRentalPropertyConditionSectionDto;
  rentersInsuranceCard?: YourRentalRinsCardDto;
  listingSection?: YourRentalListingSectionDto;
};

const Documents = ({
  leaseSection,
  propertyConditionSection,
  rentersInsuranceCard,
  listingSection,
}: DocumentsProps) => {
  return (
    <Box
      css={{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: { base: '1fr', md: '1fr', lg: 'repeat(3, 1fr)' },
        gap: 'default',
      }}
      data-testid="Documents"
    >
      <LeasesCard leaseSection={leaseSection} />
      <PropertyConditionCard
        propertyConditionSection={propertyConditionSection}
        listingAlias={listingSection?.listingAlias}
      />
      <RentersInsuranceCard rentersInsuranceCard={rentersInsuranceCard} listingAlias={listingSection?.listingAlias} />
    </Box>
  );
};

export default Documents;
